export function getState<T>(
  key: string
): { timestamp: number; value: T } | null {
  const raw_data = localStorage.getItem(key);

  if (!raw_data) {
    return null;
  }

  return JSON.parse(raw_data);
}

export function setState<T>(key: string, value: T) {
  localStorage.setItem(
    key,
    JSON.stringify({
      timestamp: Date.now(),
      value
    })
  );
}

export function delState(key: string) {
  localStorage.removeItem(key);
}
